import { Dispatch, PropsWithChildren, RefObject, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface TripLayoutContextProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>;
  containerElementRef: RefObject<HTMLDivElement>;
  isLoadingMenu: boolean;
  setIsLoadingMenu: Dispatch<SetStateAction<boolean>>;
  isMenuOpen: boolean;
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>;
}

const TripLayoutContext = createContext<TripLayoutContextProps>(undefined!);

export const TripLayoutProvider = ({ children }: PropsWithChildren) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isLoadingMenu, setIsLoadingMenu] = useState<boolean>(false);
  const location = useLocation();
  const containerElementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsDrawerOpen(false);
  }, [location]);

  const values = useMemo(
    () => ({
      isDrawerOpen,
      setIsDrawerOpen,
      containerElementRef,
      isLoadingMenu,
      setIsLoadingMenu,
      isMenuOpen,
      setIsMenuOpen,
    }),
    [isDrawerOpen, isLoadingMenu, isMenuOpen]
  );
  return <TripLayoutContext.Provider value={values}>{children}</TripLayoutContext.Provider>;
};

export function useTripLayoutContext(): TripLayoutContextProps {
  const context = useContext(TripLayoutContext);

  if (typeof context === 'undefined') {
    throw new Error('useTripLayoutContext should be used within the TripLayoutContext provider!');
  }

  return context;
}
